import * as React from 'react';
import { TZUtils } from 'lib/tzutils';
import { IRoute } from 'lib/componentRouter';
import { Location, LocationParams } from 'lib/componentLocation';
import { parseDate } from 'common/services/routeParams';
import { DateRange } from 'portcall/daterangeselector/model';
import { parseDateRange, outboundDateRangeParams } from 'portcall/daterangeselector/routeParams';
import { ReservationsInBatch, ReservationsInBatchParams } from './model';
import { ReservationsInBatchView } from './view';
import { AppWrapper } from '../appwrapper/model';
import { AppWrapperView } from '../appwrapper/view';

export const ReservationsInBatchRoute = (
    model : (params : ReservationsInBatchParams) => ReservationsInBatch, 
    appWrapper : AppWrapper,
    tzutils : TZUtils,
    request : Location
) : IRoute => {
    const m = model(inboundParams(request, tzutils));
    return {
        view:
            <AppWrapperView model={appWrapper}>
                <ReservationsInBatchView model={m} />
            </AppWrapperView>,
        reflectState: () => outboundParams(request, m)
    };
};

function inboundParams(request : Location, tzutils : TZUtils) : ReservationsInBatchParams {
    const batchId = +(request.params['batchId'] || 0),
        range = request.params['range'],
        from = request.params['from'],
        to = request.params['to'],
        filter = request.params['filter'];

    return {
        batchId,
        range: range !== undefined ? parseDateRange(range) : DateRange.AllDates,
        from: from !== undefined ? parseDate(from, tzutils) : undefined,
        to: to !== undefined ? parseDate(to, tzutils) : undefined,
        filter
    };
}

function outboundParams(request : Location, m : ReservationsInBatch) {
    const params = {} as LocationParams;
    params['batchId'] = m.BatchId + '';
    outboundDateRangeParams(m.DateRangeSelector, params, DateRange.AllDates, { range: 'range', from: 'from', to: 'to' });
    if (m.Filter()) params['filter'] = m.Filter();
    return new Location(request.name, params);
}


// WEBPACK FOOTER //
// ./apps/portcall/reservationsinbatch/route.tsx